/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_0_Item_1_DetailInputs */

const en_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four times: 2015, 2017, 2019, 2020`)
};

const es_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuatro veces: 2015, 2017, 2019, 2020`)
};

const de_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viermal: 2015, 2017, 2019, 2020`)
};

const zh_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`四次：2015年、2017年、2019年、2020年`)
};

const ar_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أربع مرات: 2015، 2017، 2019، 2020`)
};

const fr_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quatre fois : 2015, 2017, 2019, 2020`)
};

const vi_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bốn lần: 2015, 2017, 2019, 2020`)
};

const sw_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mara nne: 2015, 2017, 2019, 2020`)
};

const th_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สี่ครั้ง: 2015, 2017, 2019, 2020`)
};

const bs_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Četiri puta: 2015, 2017, 2019, 2020`)
};

const ja_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4回：2015、2017、2019、2020年`)
};

const ko_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4회: 2015, 2017, 2019, 2020`)
};

const pt_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quatro vezes: 2015, 2017, 2019, 2020`)
};

const it_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quattro volte: 2015, 2017, 2019, 2020`)
};

const sv_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fyra gånger: 2015, 2017, 2019, 2020`)
};

const nl_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vier keer: 2015, 2017, 2019, 2020`)
};

const da_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fire gange: 2015, 2017, 2019, 2020`)
};

const nb_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fire ganger: 2015, 2017, 2019, 2020`)
};

const fi_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neljä kertaa: 2015, 2017, 2019, 2020`)
};

const pl_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cztery razy: 2015, 2017, 2019, 2020`)
};

const ru_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Четыре раза: 2015, 2017, 2019, 2020`)
};

const tr_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dört kez: 2015, 2017, 2019, 2020`)
};

const hi_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चार बार: 2015, 2017, 2019, 2020`)
};

const id_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empat kali: 2015, 2017, 2019, 2020`)
};

const ms_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empat kali: 2015, 2017, 2019, 2020`)
};

const cs_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čtyřikrát: 2015, 2017, 2019, 2020`)
};

const el_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τέσσερις φορές: 2015, 2017, 2019, 2020`)
};

const he_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ארבע פעמים: 2015, 2017, 2019, 2020`)
};

const af_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vier keer: 2015, 2017, 2019, 2020`)
};

const hu_about_content_honor_0_item_1_detail = /** @type {(inputs: About_Content_Honor_0_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Négyszer: 2015, 2017, 2019, 2020`)
};

/**
* | output |
* | --- |
* | "Four times: 2015, 2017, 2019, 2020" |
*
* @param {About_Content_Honor_0_Item_1_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_0_item_1_detail = /** @type {((inputs?: About_Content_Honor_0_Item_1_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_0_Item_1_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_0_item_1_detail(inputs)
	if (locale === "de") return de_about_content_honor_0_item_1_detail(inputs)
	if (locale === "zh") return zh_about_content_honor_0_item_1_detail(inputs)
	if (locale === "ar") return ar_about_content_honor_0_item_1_detail(inputs)
	if (locale === "fr") return fr_about_content_honor_0_item_1_detail(inputs)
	if (locale === "vi") return vi_about_content_honor_0_item_1_detail(inputs)
	if (locale === "sw") return sw_about_content_honor_0_item_1_detail(inputs)
	if (locale === "th") return th_about_content_honor_0_item_1_detail(inputs)
	if (locale === "bs") return bs_about_content_honor_0_item_1_detail(inputs)
	if (locale === "ja") return ja_about_content_honor_0_item_1_detail(inputs)
	if (locale === "ko") return ko_about_content_honor_0_item_1_detail(inputs)
	if (locale === "pt") return pt_about_content_honor_0_item_1_detail(inputs)
	if (locale === "it") return it_about_content_honor_0_item_1_detail(inputs)
	if (locale === "sv") return sv_about_content_honor_0_item_1_detail(inputs)
	if (locale === "nl") return nl_about_content_honor_0_item_1_detail(inputs)
	if (locale === "da") return da_about_content_honor_0_item_1_detail(inputs)
	if (locale === "nb") return nb_about_content_honor_0_item_1_detail(inputs)
	if (locale === "fi") return fi_about_content_honor_0_item_1_detail(inputs)
	if (locale === "pl") return pl_about_content_honor_0_item_1_detail(inputs)
	if (locale === "ru") return ru_about_content_honor_0_item_1_detail(inputs)
	if (locale === "tr") return tr_about_content_honor_0_item_1_detail(inputs)
	if (locale === "hi") return hi_about_content_honor_0_item_1_detail(inputs)
	if (locale === "id") return id_about_content_honor_0_item_1_detail(inputs)
	if (locale === "ms") return ms_about_content_honor_0_item_1_detail(inputs)
	if (locale === "cs") return cs_about_content_honor_0_item_1_detail(inputs)
	if (locale === "el") return el_about_content_honor_0_item_1_detail(inputs)
	if (locale === "he") return he_about_content_honor_0_item_1_detail(inputs)
	if (locale === "af") return af_about_content_honor_0_item_1_detail(inputs)
	if (locale === "hu") return hu_about_content_honor_0_item_1_detail(inputs)
	return en_about_content_honor_0_item_1_detail(inputs)
});